<template>
  <q-page class="q-pa-md bg-grey-2">
    <!-- Card Datos de Usuario -->
    <q-card class="q-mb-md shadow-2 rounded-borders">
      <q-card-section class="bg-primary text-white row items-center justify-between q-py-md">
        <div class="text-h6 text-weight-bold row items-center">
          <q-icon name="person" class="q-mr-sm" size="sm" />
          Datos del Usuario: {{ usuario.nombres }} {{ usuario.apellidos }}
        </div>
      </q-card-section>

      <q-card-section class="q-pa-md">
        <div class="row q-col-gutter-md">
          <div class="col-12 col-sm-3">
            <q-input v-model="usuario.dni" label="DNI" outlined dense disable />
          </div>
          <div class="col-12 col-sm-9">
            <q-input v-model="usuario.nombres" label="Nombres" outlined dense disable />
          </div>
        </div>

        <div class="row q-col-gutter-md q-mt-xs">
          <div class="col-12 col-sm-4">
            <q-input v-model="usuario.apellidos" label="Apellidos" outlined dense disable />
          </div>
          <div class="col-12 col-sm-4">
            <q-input v-model="usuario.telefono" label="Teléfono" outlined dense disable />
          </div>
          <div class="col-12 col-sm-4">
            <q-input v-model="usuario.email" label="Email" outlined dense disable />
          </div>
        </div>
      </q-card-section>
    </q-card>

    <!-- Card Planes del Usuario -->
    <q-card class="shadow-2 rounded-borders">
      <q-card-section class="bg-primary text-white row items-center justify-between q-py-md">
        <div class="text-h6 text-weight-bold row items-center">
          <q-icon name="subscriptions" class="q-mr-sm" size="sm" />
          Planes Asignados
        </div>
        <q-btn
          color="white"
          text-color="primary"
          icon="add"
          label="Agregar Plan"
          unelevated
          rounded
          class="text-weight-bold"
          @click="DialogNuevoServicio"
        />
      </q-card-section>

      <q-card-section class="q-pa-none">
        <q-table
          :data="ListaServ"
          :columns="columns"
          row-key="idusuarioplan"
          flat
          bordered
          no-data-label="No hay planes asignados a este usuario"
        >
          <!-- Estado Toggle Slot -->
          <template v-slot:body-cell-estado="props">
            <q-td :props="props">
              <q-toggle
                v-model="props.row.estadoBool"
                color="primary"
                @input="Activar(props.row)"
              />
            </q-td>
          </template>

          <!-- Acciones Slot -->
          <template v-slot:body-cell-actions="props">
            <q-td :props="props" class="text-right">
              <q-btn
                flat
                round
                color="negative"
                icon="delete"
                size="sm"
                @click="EliminarServicio(props.row)"
              >
                <q-tooltip>Eliminar Plan</q-tooltip>
              </q-btn>
            </q-td>
          </template>
        </q-table>
      </q-card-section>
    </q-card>

    <!-- Modal Plan Usuario -->
    <plan-usuario
      @CerrarModal="CerrarModalServicio"
      :DialogServicio="DialogPlan"
      :Servicio="DatosServicio"
    />
  </q-page>
</template>

<script>
import PlanUsuario from "@/pages/Usuario/UsuarioPlan";
import axios from "axios";

export default {
  components: { PlanUsuario },
  data() {
    return {
      dialog: false,
      DialogPlan: false,
      ListaServ: [],
      id_usuario: "",
      usuario: {
        nombres: "",
        apellidos: "",
        email: "",
        dni: "",
        telefono: "",
        estado: "",
      },
      DatosServicio: {
        id_usuario: "",
        idplan: "",
        fechainicio: "",
        fechafin: "",
        estado: "activo",
      },
      columns: [
        { name: "idusuarioplan", label: "Id", field: "idusuarioplan", align: "left" },
        { name: "nombre", label: "Plan", field: "nombre", align: "left" },
        { name: "tipo", label: "Tipo", field: "tipo", align: "center" },
        { name: "estado", label: "Estado", field: "estado", align: "center" },
        { name: "fechainicio", label: "Inicio", field: "fechainicio", align: "center" },
        { name: "fechafin", label: "Fin", field: "fechafin", align: "center" },
        { name: "actions", label: "Acciones", field: "actions", align: "right" },
      ],
    };
  },
  created() {
    this.id_usuario = this.$route.params.id;
    this.DatosServicio.id_usuario = this.id_usuario;
    this.GetUsuario();
    this.Listar();
  },
  methods: {
    DialogNuevoServicio() {
      this.DialogPlan = true;
    },
    CerrarModalServicio() {
      this.DialogPlan = false;
      this.Listar();
    },
    GetUsuario() {
      let me = this;
      axios.post("ApiWeb/UsuarioId.php", { id_usuario: this.id_usuario })
        .then((res) => {
          if (res.data && res.data.data) {
            me.usuario = res.data.data;
          }
        })
        .catch((err) => console.error(err));
    },
    Listar() {
      let me = this;
      axios.post("ApiWeb/PlanUsuarioLista.php", { id_usuario: this.id_usuario })
        .then((res) => {
          if (res.data && res.data.data) {
            me.ListaServ = res.data.data.map((item) => ({
              ...item,
              estadoBool: item.estado === "activo",
            }));
          }
        })
        .catch((err) => console.error(err));
    },
    Activar(item) {
      let nuevoEstado = item.estadoBool ? "activo" : "inactivo";
      axios.post("ApiWeb/PlanUsuarioActivar.php", {
        idusuarioplan: item.idusuarioplan,
        estado: nuevoEstado,
      })
        .then(() => {
          item.estado = nuevoEstado;
        })
        .catch((err) => console.error(err));
    },
    EliminarServicio(item) {
      if (confirm("¿Desea eliminar este plan asignado?")) {
        let me = this;
        axios.post("ApiWeb/PlanUsuarioEliminar.php", {
          idusuarioplan: item.idusuarioplan,
        })
          .then(() => me.Listar())
          .catch((err) => console.error(err));
      }
    },
  },
};
</script>
